import { deduplicateByProperty, NamedProperty } from "sprint-common-web";

import { ContentDetails } from "../../../../common/types/ContentDetails";
import { ContentReference } from "../../../../common/types/ContentReference";
import { ContentReferenceType } from "../../../../common/types/ContentReferenceType";

export const mapContentReferenceToAssetOperationContentDetails = (
    contentReference: ContentReference
): ContentDetails => {
    switch (contentReference.type) {
        case ContentReferenceType.Movie: {
            return {
                type: ContentReferenceType.Movie,
                subtype: contentReference.subtype,
                movie: { id: contentReference.movie.id, name: contentReference.movie.title },
                versions: contentReference.versions,
                versionSummary: mapToVersionSummary(contentReference.versions)
            };
        }

        case ContentReferenceType.TvSeries: {
            return {
                type: ContentReferenceType.TvSeries,
                subtype: contentReference.subtype,
                tvSeries: { id: contentReference.tvSeries.id, name: contentReference.tvSeries.title },
                season: contentReference.season
                    ? { id: contentReference.season.id, name: contentReference.season.name }
                    : undefined,
                episode: contentReference.episode
                    ? { id: contentReference.episode.id, name: contentReference.episode.title }
                    : undefined,
                versions: contentReference.versions,
                versionSummary: mapToVersionSummary(contentReference.versions)
            };
        }

        case ContentReferenceType.Ancillary: {
            return {
                type: ContentReferenceType.Ancillary,
                subtype: contentReference.subtype,
                ancillary: { id: contentReference.ancillary.id, name: contentReference.ancillary.title },
                airline: contentReference.airline,
                versionSummary: mapToVersionSummary([contentReference.ancillary.version])
            };
        }

        default:
            throw new Error("Unsupported content reference type");
    }
};

const mapToVersionSummary = (versions: { id: string; type: NamedProperty; distributor?: NamedProperty }[]) => ({
    ids: versions.map((version) => version.id),
    versionType: versions[0].type,
    distributors: deduplicateByProperty<NamedProperty>(
        versions
            .map((version) => version.distributor)
            .filter((distributor): distributor is NamedProperty => !!distributor),
        "id"
    ),
    brandings: []
});
